"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = __importStar(require("js-cookie"));
var isDev_1 = require("../isDev");
var url = "ua.serverdata.net";
exports.InternalAnalytics = {
    id: undefined,
    baseProps: undefined,
    initialise: function (id) {
        var _this = this;
        if (!id) {
            throw new Error("You must initialise the analytics service");
        }
        tryToGetSession()
            .then(function (baseProps) {
            _this.id = id;
            _this.baseProps = baseProps;
            window.DEBUG = isDev_1.isDev();
        })
            .catch(function () {
            return console.error("Internal analytics failed to get base properties. No events will be logged");
        });
    },
    recordEvent: function (action) {
        if (this.baseProps) {
            this.record(action);
        }
    },
    record: function (action) {
        var sessionId = Cookies.get("admin.session");
        var event = {
            app: this.id,
            eventName: action,
            timestamp: Date.now(),
            sessionId: sessionId,
            accountId: this.baseProps.accountId,
            partnerId: this.baseProps.partnerId,
            username: this.baseProps.username,
            url: window.location.href,
            viewport: {
                width: window.innerWidth,
                height: window.innerHeight,
            },
        };
        var jsonEvent = JSON.stringify(event);
        if (window.DEBUG) {
            console.log("Running in debug mode, logging event to console:");
            console.log(jsonEvent);
            return;
        }
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "https://" + url + "/api/v1/in", true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status !== 200) {
                    console.warn("Failed to record event, you need to initialise analytics https://bitbucket.org/intermediasecurity/core-components/wiki/Home");
                }
            }
        }.bind(this);
        xhr.send(jsonEvent);
    },
};
function tryToGetSession() {
    return new Promise(function (resolve, reject) {
        var session = Cookies.get("admin.session");
        var sessionId, partnerId, accountId, username;
        if (session) {
            sessionId = session.split("=")[1];
            try {
                var adminInfo = Cookies.get("admin.info");
                if (adminInfo) {
                    var adminInfoObj = JSON.parse(adminInfo);
                    partnerId = adminInfoObj.partnerIdentifier;
                    accountId = adminInfoObj.accountIdentifier;
                    username = adminInfoObj.userIdentifier;
                }
            }
            catch (err) {
                reject();
            }
            resolve({
                sessionId: sessionId,
                partnerId: partnerId,
                accountId: accountId,
                username: username,
            });
        }
        var guid = getGuidFromUrl();
        if (guid) {
            sessionId = guid;
            resolve({ sessionId: sessionId, partnerId: partnerId, accountId: accountId, username: username });
        }
        reject();
    });
}
/**
 * getGuidFromUrl - this is obviously a bad idea once we get past using this for only partner QoS
 * and hunt group dashboard but for now it will do
 */
function getGuidFromUrl() {
    var guid;
    try {
        var pathBits = window.location.pathname.split("/");
        guid = pathBits[pathBits.length - 1];
        //Allow for final /
        if (guid.length == 0 && pathBits.length > 1) {
            guid = pathBits[pathBits.length - 2];
        }
    }
    catch (e) {
        // noop - let calling code handle the undefined guid
    }
    return guid;
}
